// extracted by mini-css-extract-plugin
export default {"tagsContainer":"App_tagsContainer__3vaFt","backToTop":"App_backToTop__FizaF","App":"App_App__X44vc","content":"App_content__uFknh"};